(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('EmployeeSummaryController', Controller);

    Controller.$inject = ['$q', '$scope', '$state', '$translate', 'authenticatedUser', 'fromDateWhenArrivalRequest', 'employee', 'employeeProfileService', 'eventService'];

    function Controller($q, $scope, $state, $translate, authenticatedUser, fromDateWhenArrivalRequest, employee, employeeProfileService, eventService) {

        $scope.authenticatedUser = authenticatedUser;
        $scope.employee = employee;
        $scope.isRestrictedZone = false;

        $q.all({
            accessRequests    : employeeProfileService.getAllAccessRequests({ EmployeeID: employee.EmployeeID }),
            systemRolesPending: employeeProfileService.getAllSystemRolePending({ EmployeeID: employee.EmployeeID }),
            employeeEvents    : employeeProfileService.getEventsForEmployee({ EmployeeID: employee.EmployeeID })
        })
        .then(function (data) {
            if ((!_.isUndefined(data.accessRequests) && data.accessRequests.IsRestrictedZone === true) ||
                (!_.isUndefined(data.systemRolesPending) && data.systemRolesPending.IsRestrictedZone === true) ||
                (!_.isUndefined(data.employeeEvents) && data.employeeEvents.IsRestrictedZone === true)) {

                $scope.isRestrictedZone = true;
                return $q.reject('IsRestrictedZone');
            }
            return data;
        })
        .then(function (data) {
            $scope.combinedEvents = _.union(addSysRoles(data.accessRequests, data.systemRolesPending),
                                            data.employeeEvents);
        });

        $translate('iam.employee.summary.pageTitle').then(function(translation) {
            $scope.updateTopBar(translation, 'fa fa-tachometer');
        });

        $scope.isInTheFuture  = function (date) {
            return moment(date).isAfter(Date.now());
        }

        $scope.lastUpdateTimeAgo = function (lastUpdt) {
            if (!_.isUndefined(lastUpdt))
                return true;
            return false;
        }

        $scope.showAccessCardUpdate = function (empMvt) {
            return empMvt.EventTypeEnum === 22;
        }

        $scope.showPasswordReset = function (empMvt) {
            return empMvt.EventTypeEnum === 23;
        }

        $scope.showAccountChange = function (empMvt) {
            return empMvt.EventTypeEnum === 24;
        }

        $scope.showConfirmOnBoardingAction = function (empMvt) {
            if (!$scope.authenticatedUser.IsInITServiceDeskGroup) return false;
            if (empMvt.EventStatusID !== 75) return false; // ConfirmOnBoardingByServiceDesk

            return empMvt.TaskStateStatusId === 2; // PENDING
        }

        $scope.showConfirmOnBoardingConfirmed = function (empMvt) {
            if (empMvt.EventStatusID !== 75) return false; // ConfirmOnBoardingByServiceDesk

            return empMvt.TaskStateStatusId === 8; // CONFIRMED
        }

        $scope.showDefault = function (empMvt) {
            if (empMvt.EventTypeEnum === 13) return false;
            if ($scope.showAccessCardUpdate(empMvt)) return false;
            if ($scope.showPasswordReset(empMvt)) return false;
            if ($scope.showAccountChange(empMvt)) return false;

            return true;
        }

        $scope.lastActive  = function (historyEvent) {
            if (historyEvent.isUserRequest) {
                return historyEvent.UpdatedTimestamp;
            } else {
                return historyEvent.CreationDate;
            }
        }

        // Confirm OnBoarding
        $scope.confirmOnBoarding = function (historyEvent) {
            eventService
                .continueProcessAfterPendingEvent(historyEvent.EventID)
                .then(function () {
                    $state.reload();
                });
        };

        // Helpers
        function addSysRoles(accessReqs, sysRolesPending) {
            return _.chain(accessReqs)
                    .map(function (accessReq) {
                        return _.extend(accessReq, {
                            isUserRequest: true,
                            systemRolesPending: _.filter(sysRolesPending, { UserAccessRequestID: accessReq.UserAccessRequestID })
                        })
                    })
                    .value();
        }
    }
})();